import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--bg-secondary)] border-t border-[var(--border-light)] pt-16 pb-8">
      <div className="container mx-auto px-6 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          {/* About Section */}
          <div className="space-y-4">
            <img 
              src="https://customer-assets.emergentagent.com/job_tech-foundation-6/artifacts/i8tnchox_KKF_logo-removebg-preview.png" 
              alt="KK Foundation Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="body-standard text-[var(--text-secondary)]">
              Building a better and inclusive world by harnessing the power of technology to solve real-world challenges.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="heading-medium text-[var(--text-primary)]">Quick Links</h3>
            <nav className="flex flex-col space-y-2">
              <Link to="/home" className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors">
                Home
              </Link>
              <Link to="/about" className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors">
                About Us
              </Link>
              <Link to="/services" className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors">
                Services
              </Link>
              <Link to="/contact" className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors">
                Contact
              </Link>
            </nav>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="heading-medium text-[var(--text-primary)]">Our Solutions</h3>
            <div className="flex flex-col space-y-2">
              <a 
                href="https://boneah.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors flex items-center gap-2"
              >
                BoneAH <ExternalLink size={14} />
              </a>
              <span className="body-standard text-[var(--text-secondary)]">
                IQplayground
              </span>
              <span className="body-standard text-[var(--text-secondary)]">
                Speak to the God
              </span>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="heading-medium text-[var(--text-primary)]">Contact Us</h3>
            <div className="flex flex-col space-y-3">
              <div className="flex items-start gap-3">
                <MapPin size={18} className="text-[var(--brand-primary)] mt-1 flex-shrink-0" />
                <span className="body-standard text-[var(--text-secondary)]">
                  SK Residency, Thumkunta,<br />
                  Hyderabad, Telangana - 500078
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={18} className="text-[var(--brand-primary)] flex-shrink-0" />
                <a 
                  href="mailto:kkfoundation2025@gmail.com" 
                  className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors"
                >
                  kkfoundation2025@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={18} className="text-[var(--brand-primary)] flex-shrink-0" />
                <div className="flex flex-col">
                  <a 
                    href="tel:+918985709090" 
                    className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors"
                  >
                    +91 8985709090
                  </a>
                  <a 
                    href="tel:+918985709595" 
                    className="body-standard text-[var(--text-secondary)] hover:text-[var(--brand-primary)] transition-colors"
                  >
                    +91 8985709595
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[var(--border-medium)] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="body-small text-[var(--text-caption)]">
              © {currentYear} Kodamalas Krushi Foundation. All rights reserved.
            </p>
            <p className="body-small text-[var(--text-caption)]">
              Empowering communities through technology
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;